import { render, staticRenderFns } from "./AddClientFormal.vue?vue&type=template&id=744ed8c9&"
import script from "./AddClientFormal.vue?vue&type=script&lang=js&"
export * from "./AddClientFormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports